module.exports = __webpack_public_path__ + "img/icon_sm_scrb.4aee5b82.png";